<template>

	<div
		:class="{
					'app_wrapper': mapStatus == 1,
					'': mapStatus == 0,
					'': mapStatus == 2,
				}"
		v-show="!$store.state.isMain">
				
		

			<div :class="{
							'map_side_wrapper nearbymapContainer': mapStatus == 1,
							'no_map_wrapper nearbymapContainer': mapStatus == 0,
							'map_full_wrapper nearbymapContainer': mapStatus == 2
						} ">
						<div class="roomPricingMap" v-show="$store.state.showMap == true">
							<div v-if="clickedNeighborhoodName == null || clickedNeighborhoodName == ''" id="currentPagePrice" class="priceBox priceBox_main">
								<div class="currNeighborhod">
									<div v-if="$store.state.neighborhoodName" class="title">
										{{ $store.state.neighborhoodName }}
										{{ $store.state.settlementName }}
									</div>
									<div v-else class="title">
										{{ $store.state.settlementName }}
									</div>
									<div
										v-if="
											
											$store.state.lastYearAvgPrice != null
										"
										class="subTitle" style="margin-bottom: 6px;"
									>
										₪{{ $store.state.lastYearAvgPrice.toLocaleString() }}
										
									</div>
									<div
									v-if="$store.state.lastYearAvgPrice_3" class="subTitle" style="font-size: 17px; color: #5e6987;">
										3 חדרים ₪{{ $store.state.lastYearAvgPrice_3.toLocaleString() }}
									</div>
									<div
									v-if="$store.state.lastYearAvgPrice_4" class="subTitle" style="font-size: 17px; color: #5e6987;">
										4 חדרים ₪{{ $store.state.lastYearAvgPrice_4.toLocaleString() }}
									</div>
									<div
									v-if="$store.state.lastYearAvgPrice_5" class="subTitle" style="font-size: 17px; color: #5e6987;">
										5 חדרים ₪{{ $store.state.lastYearAvgPrice_5.toLocaleString() }}
									</div>
								</div>
								<div
									v-if="$store.state.lastYearAvgSetlPrice != null"
									class="selNeighborhod"
								>
									<div class="title">ממוצע בישוב כ-</div>
									<div class="subTitle">
										₪{{ $store.state.lastYearAvgSetlPrice.toLocaleString() }}
									</div>
								</div>
							</div>
							<div v-else id="selectionMapPrice" class="priceBox priceBox_main">
								<div class="currNeighborhod">
									<div class="title">{{ clickedNeighborhoodName }}</div>
									<div v-if="clickedRentPrice > 0" class="subTitle"  style="margin-bottom: 6px;"> {{ clickedRentPrice.toLocaleString() }} ₪</div>
									<div v-if="clickedRentPrice_3 > 0" class="subTitle" style="font-size: 17px; color: #5e6987;">
										3 חדרים {{ clickedRentPrice_3.toLocaleString() }} ₪
									</div>
									<div v-if="clickedRentPrice_4 > 0" class="subTitle" style="font-size: 17px; color: #5e6987;">
										4 חדרים {{ clickedRentPrice_4.toLocaleString() }} ₪
									</div>
									<div v-if="clickedRentPrice_5 > 0" class="subTitle" style="font-size: 17px; color: #5e6987;">
										5 חדרים {{ clickedRentPrice_5.toLocaleString() }} ₪
									</div>
								</div>
							</div>

						</div>
						<MapDiv ref="map" id="map" />
						<button 
						:title="selectFromMapToolTip" 
						style="position: absolute; top: 10px; right: 10px; z-index: 9;"
						@click="allowMapSelection('Point')">
						<div :class="{
							'map-action-after': true,
							'active': $store.state.mapSelectionType == 'Point'
							}" v-show="$store.state.mapStatus > 0">
							<svg height="35" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.416 9.95615C21.1115 10.2487 20.9167 10.614 20.8327 10.9982C20.0759 10.6168 19.1267 10.7309 18.4813 11.3509C18.1768 11.6435 17.982 12.0088 17.898 12.393C17.1412 12.0116 16.192 12.1256 15.5467 12.7457C15.277 13.0048 15.0934 13.3209 14.9973 13.6569L12.6701 11.2348C11.8848 10.4175 10.5816 10.3914 9.76439 11.1767C8.94713 11.9619 8.92108 13.2651 9.70631 14.0823L18.0291 22.7446L15.0134 23.6828C14.5593 23.8241 14.1379 24.0737 13.7948 24.4033C13.0139 25.1536 12.9897 26.398 13.7436 27.1827C14.1074 27.5613 14.5958 27.7745 15.1203 27.785L24.5143 27.9728C26.6376 28.0159 28.6518 27.2277 30.184 25.7555C32.8395 23.2041 32.9242 18.9677 30.3728 16.3122L24.3217 10.0142C23.5365 9.19697 22.2333 9.17092 21.416 9.95615ZM29.6318 17.0241C31.791 19.2713 31.7186 22.8561 29.4713 25.0153C28.1369 26.2974 26.3842 26.9825 24.5348 26.9442L15.1402 26.7571C14.891 26.7528 14.6576 26.6508 14.4803 26.4663C14.123 26.0944 14.1348 25.5016 14.5067 25.1443C14.7357 24.9243 15.0159 24.7591 15.3193 24.6641L19.1285 23.478C19.2981 23.4247 19.4295 23.2871 19.4729 23.1157C19.5171 22.9437 19.4691 22.7603 19.3459 22.6321L10.4473 13.3704C10.055 12.9622 10.0673 12.3106 10.4763 11.9176C10.8853 11.5247 11.5369 11.5384 11.9291 11.9467L18.6921 18.9855C18.8886 19.19 19.214 19.1965 19.4185 19.0001C19.623 18.8036 19.6295 18.4781 19.4331 18.2736L16.2295 14.9394C15.8373 14.5312 15.8496 13.8796 16.2586 13.4866C16.6676 13.0937 17.3192 13.1074 17.7114 13.5157L20.9149 16.8499C21.1114 17.0544 21.4368 17.0609 21.6413 16.8644C21.8458 16.6679 21.8523 16.3424 21.6559 16.1379L19.1642 13.5447C18.772 13.1364 18.7843 12.4848 19.1933 12.0919C19.6023 11.6989 20.2538 11.7127 20.6461 12.1209L23.1377 14.7142C23.3342 14.9187 23.6596 14.9252 23.8641 14.7287C24.0686 14.5322 24.0751 14.2068 23.8787 14.0023L22.0989 12.1499C21.7066 11.7416 21.7189 11.0901 22.1279 10.6971C22.5369 10.3041 23.1885 10.3179 23.5807 10.7261L29.6318 17.0241Z" fill="#1C1C1C"></path><path d="M5.81327 9.8814C6.092 9.24242 6.49385 8.6646 6.99589 8.18092C7.49793 7.69724 8.09032 7.31718 8.73924 7.06245C9.38816 6.80771 10.0809 6.68328 10.7779 6.69627C11.4749 6.70925 12.1625 6.85939 12.8015 7.13812C13.4031 7.40054 13.9505 7.7721 14.4161 8.23366L13.532 9.08549C13.1784 8.73983 12.7647 8.46106 12.3108 8.26308C11.8196 8.0488 11.2909 7.93337 10.7551 7.92338C10.2192 7.9134 9.68661 8.00906 9.18772 8.20491C8.68883 8.40075 8.2334 8.69293 7.84743 9.06479C7.46146 9.43664 7.15252 9.88087 6.93823 10.3721C6.72394 10.8634 6.60851 11.392 6.59853 11.9279C6.58855 12.4637 6.68421 12.9963 6.88005 13.4952C7.06098 13.9561 7.32415 14.3799 7.6564 14.7462L6.77223 15.598C6.32834 15.1155 5.97742 14.5546 5.73759 13.9437C5.48285 13.2948 5.35842 12.602 5.37141 11.905C5.38439 11.208 5.53454 10.5204 5.81327 9.8814Z" fill="#1C1C1C" stroke="white" stroke-width="0.244585"></path></svg>
						</div>
						</button>
						<button title="ביטול סימון"
							v-show="$store.state.mapSelectionAllowed"
							class="cancelSelectAssetBtn showBtn"
							style="position: absolute; top: 10px; right: 50px; z-index: 9;"
							@click="dissallowMapSelection()"
						>
						</button>
						<!-- <div
						v-show="clickedNeighborhoodName"
						role="tooltip"
						x-placement="right"
						class="legendPopover popover bs-popover-right"
						id="mapBubble"
						style="
							top: 45%;
							left: 45%;
							opacity: 1;
							z-index: 1;
							position: absolute;
						"
					>
						<div class="arrow"></div>
						<div class="popover-body">
							<div class="priceBox">
								<div class="selNeighborhod tooltipData">
									<div class="title">{{ clickedNeighborhoodName }}</div>
									<div v-if="clickedRentPrice > 0" class="title"> {{ clickedRentPrice.toLocaleString() }} ₪</div>
									<div v-if="clickedRentPrice_3 > 0" class="subTitle">
										3 חדרים {{ clickedRentPrice_3.toLocaleString() }} ₪
									</div>
									<div v-if="clickedRentPrice_4 > 0" class="subTitle">
										4 חדרים {{ clickedRentPrice_4.toLocaleString() }} ₪
									</div>
									<div v-if="clickedRentPrice_5 > 0" class="subTitle">
										5 חדרים {{ clickedRentPrice_5.toLocaleString() }} ₪
									</div>
								</div>
							</div>
						</div>
						</div> -->
					
				</div>
						
			<div :class="{
				'info_side': mapStatus == 1,
				'': mapStatus == 0,
				'': mapStatus == 2
			}" >


		
		<div class="hello">
			<div v-if="$store.state.loading == true" class="loading-container">
				<svg viewBox="25 25 50 50" class="loader-svg">
					<circle
						class="loader-path"
						cx="50"
						cy="50"
						r="20"
						fill="none"
						stroke="#1990d4"
						stroke-width="2"
					/>
				</svg>
			</div>

			<div class="nadlan-page mainAppPage" v-show="$store.state.loading == false">
				<BreadCrumbs></BreadCrumbs>
				<div class="buyerDealsComp innerPage">
					<section class="trendsSection sectionPadBottom">
						<div class="container-fluid">
							<div class="whiteContainer">
								<div class="titleContainer">
									<h2 class="title">מגמות השכירות ב{{ resultTypeDesc }}</h2>
									<p class="plainText">בהתייחס לשנה האחרונה</p>
								</div>
								<TrendCards></TrendCards>
								<div class="bottomTrends">
									<div class="titleTabsWrap">
										<h3 class="title">מגמות לפי מספר חדרים</h3>
									</div>
									<div class="tab-content">
										<div
											role="tabpanel"
											aria-hidden="false"
											class="fade tab-pane active show"
										>
											<TargetContainer ref="target_container"></TargetContainer>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
						<!-- <h2 v-if="checkRouteType.startsWith('neighborhood')" class="title">
								מחירי שכירות בשכונה וסביבתה
							</h2> -->
					<!-- <div
						v-show="$store.state.showMap"
						class="container-fluid rentalPrices sectionPadBottom"
					>
						<div class="titleContainer">
						
							<h2 v-if="checkRouteType.startsWith('settlement')" class="title">
								מחירי שכירות בישוב
							</h2>
							<p class="plainText">הנתונים מייצגים מחיר חציוני</p>
						</div>
						<div class="roomPricingMap" v-show="$store.state.showMap == true">
							<div class="priceBox">
								<div class="currNeighborhod">
									<div v-if="$store.state.neighborhoodName" class="title">
										{{ $store.state.neighborhoodName }}
										{{ $store.state.settlementName }}
									</div>
									<div v-else class="title">
										{{ $store.state.settlementName }}
									</div>
									<div
										v-if="
											
											$store.state.lastYearAvgPrice != null
										"
										class="subTitle"
									>
										₪{{ $store.state.lastYearAvgPrice.toLocaleString() }}
									</div>
								</div>
								<div
									v-if="$store.state.lastYearAvgSetlPrice != null"
									class="selNeighborhod"
								>
									<div class="title">ממוצע בישוב כ-</div>
									<div class="subTitle">
										₪{{ $store.state.lastYearAvgSetlPrice.toLocaleString() }}
									</div>
								</div>
							</div>
							<div
								v-show="clickedNeighborhoodName"
								role="tooltip"
								x-placement="right"
								class="legendPopover popover bs-popover-right"
								id="inputForm"
								style="
									top: 45%;
									left: 45%;
									opacity: 1;
									z-index: 1;
									position: absolute;
								"
							>
								<div class="arrow"></div>
								<div class="popover-body">
									<div class="priceBox">
										<div class="selNeighborhod tooltipData">
											<div class="title">{{ clickedNeighborhoodName }}</div>
											<div v-if="clickedRentPrice > 0" class="subTitle">
												{{ clickedRentPrice.toLocaleString() }} ₪
											</div>
										</div>
									</div>
								</div>
							</div>
							<div style="margin-top: 20px; position: relative;" v-show="$store.state.showMap">
								<MapDiv ref="map" v-show="$store.state.showMap" />
								<button 
								title="סימון נכס במפה" 
								class="selectAssetBtn"
								style="position: absolute; top: 10px; right: 10px; z-index: 9;"
								@click="allowMapSelection()">
								</button>
								<button title="ביטול סימון"
									v-show="$store.state.mapSelectionAllowed"
									class="cancelSelectAssetBtn showBtn"
									style="position: absolute; top: 10px; right: 50px; z-index: 9;"
									@click="dissallowMapSelection()"
								>
								</button>

							</div>

						</div>
					</div> -->
					<NeighScroller ref="neigh_scroller" />
				</div>
			</div>
		</div>
		<footer
		class="footer" 
		
		v-if="$store.state.loading == false "
	>
		<div class="personalArea">
			<h3 class="title">עסקאות חדשות לידי? יש פרויקט חדש בשכונה?</h3>
			<p class="plainText">
				קבלו מידע עדכני על סביבת המגורים שלכם ישירות למייל
			</p>
		</div>
		<button @click="$parent.$parent.showRegister()" class="btn blue round">
			הירשמו לקבלת עדכונים
		</button>
		<ul class="footerLinks">
			<li class="linkWrap">
				<button type="button" @click="$parent.$parent.showContact()" class="link">
					יצירת קשר
				</button>
			</li>
			<li class="linkWrap">
				<button class="link" @click="$parent.$parent.goToTerms()">תנאי שימוש</button>
			</li>
			<li class="linkWrap">
				<button class="link" @click="$parent.$parent.goToAccess()">נגישות</button>
			</li>
			<li class="linkWrap">
				<button class="link" @click="$parent.$parent.goToAbout()">אודות</button>
			</li>
		</ul>
	</footer>
		</div>
		
	</div>
	
</template>

<script>



	//import GraphCard from "./Graph";
	import MapDiv from "./Map";
	import NeighScroller from "./NeighScroller";
	import TargetContainer from "./TargetContainer";
	import BreadCrumbs from "./BreadCrumbs";
	import TrendCards from "./TrendCards";

	

	export default {
		name: "RentsComp",
		props: {
			msg: String,
		},
		components: {
			MapDiv,
			NeighScroller,
			TargetContainer,
			BreadCrumbs,
			TrendCards,
		},
		data() {
			return {
				mapSet: false,
				showShare: false,
				componentName: "RentsComp",

				activeIndex: 0,
				tabs: [
					{ key: "all", label: "כל החדרים" },
					{ key: "3", label: "3 חדרים" },
					{ key: "4", label: "4 חדרים" },
					{ key: "5", label: "5 חדרים" },
				],
				selectedTab: "all",
				toggle_exclusive: 0,
				similarNeighborhoods: [
					// { neighborhoodId: 65209720, neighborhoodName: "מרכז" },
					// { neighborhoodId: 65210202, neighborhoodName: "פועלים ב" },
					// { neighborhoodId: 65209721, neighborhoodName: "שיכוני מזרחי" },
					// { neighborhoodId: 65210764, neighborhoodName: "מעוז" },
				],
				otherNeighborhoodStreets: [
					// {
					// 	assets_neighborhoodid: 65209946,
					// 	id: 69000321.0,
					// 	dealsInRooms: [
					// 		{ roomNum: 2.0 },
					// 		{ roomNum: 3.0 },
					// 		{ roomNum: 4.0 },
					// 		{ roomNum: 5.0 },
					// 		{ roomNum: 6.0 },
					// 		{ roomNum: 7.0 },
					// 	],
					// 	title: "הכרמל",
					// },
					// {
					// 	assets_neighborhoodid: 65209946,
					// 	id: 69000340.0,
					// 	dealsInRooms: [
					// 		{ roomNum: 1.0 },
					// 		{ roomNum: 3.0 },
					// 		{ roomNum: 4.0 },
					// 		{ roomNum: 5.0 },
					// 		{ roomNum: 6.0 },
					// 	],
					// 	title: "כצנלסון ברל",
					// },
					// {
					// 	assets_neighborhoodid: 65209946,
					// 	id: 69000520.0,
					// 	dealsInRooms: [
					// 		{ roomNum: 3.0 },
					// 		{ roomNum: 4.0 },
					// 		{ roomNum: 5.0 },
					// 		{ roomNum: 6.0 },
					// 	],
					// 	title: "הרצל",
					// },
					// {
					// 	assets_neighborhoodid: 65209946,
					// 	id: 69000523.0,
					// 	dealsInRooms: [
					// 		{ roomNum: 0.0 },
					// 		{ roomNum: 2.0 },
					// 		{ roomNum: 3.0 },
					// 		{ roomNum: 4.0 },
					// 		{ roomNum: 5.0 },
					// 	],
					// 	title: "ויצמן",
					// },
					// {
					// 	assets_neighborhoodid: 65209946,
					// 	id: 69000527.0,
					// 	dealsInRooms: [
					// 		{ roomNum: 4.0 },
					// 		{ roomNum: 5.0 },
					// 		{ roomNum: 6.0 },
					// 		{ roomNum: 7.0 },
					// 	],
					// 	title: "ירושלים",
					// },
					// {
					// 	assets_neighborhoodid: 65209946,
					// 	id: 69000528.0,
					// 	dealsInRooms: [
					// 		{ roomNum: 4.0 },
					// 		{ roomNum: 5.0 },
					// 		{ roomNum: 6.0 },
					// 	],
					// 	title: "כנרת",
					// },
					// {
					// 	assets_neighborhoodid: 65209946,
					// 	id: 69000534.0,
					// 	dealsInRooms: [
					// 		{ roomNum: 2.0 },
					// 		{ roomNum: 3.0 },
					// 		{ roomNum: 4.0 },
					// 		{ roomNum: 5.0 },
					// 	],
					// 	title: "רוטשילד",
					// },
					// {
					// 	assets_neighborhoodid: 65209946,
					// 	id: 69000571.0,
					// 	dealsInRooms: [
					// 		{ roomNum: 3.0 },
					// 		{ roomNum: 4.0 },
					// 		{ roomNum: 5.0 },
					// 		{ roomNum: 6.0 },
					// 		{ roomNum: 7.0 },
					// 	],
					// 	title: "המיסדים",
					// },
					// {
					// 	assets_neighborhoodid: 65209946,
					// 	id: 69000587.0,
					// 	dealsInRooms: [
					// 		{ roomNum: 4.0 },
					// 		{ roomNum: 5.0 },
					// 		{ roomNum: 6.0 },
					// 	],
					// 	title: "גבורי ישראל",
					// },
					// {
					// 	assets_neighborhoodid: 65209946,
					// 	id: 69000590.0,
					// 	dealsInRooms: [
					// 		{ roomNum: 2.0 },
					// 		{ roomNum: 3.0 },
					// 		{ roomNum: 4.0 },
					// 		{ roomNum: 5.0 },
					// 		{ roomNum: 6.0 },
					// 	],
					// 	title: "ארבל",
					// },
					// {
					// 	assets_neighborhoodid: 65209946,
					// 	id: 69000591.0,
					// 	dealsInRooms: [
					// 		{ roomNum: 4.0 },
					// 		{ roomNum: 5.0 },
					// 		{ roomNum: 8.0 },
					// 	],
					// 	title: "האלה",
					// },
					// {
					// 	assets_neighborhoodid: 65209946,
					// 	id: 69000597.0,
					// 	dealsInRooms: [{ roomNum: 4.0 }, { roomNum: 5.0 }],
					// 	title: "צאלון",
					// },
					// {
					// 	assets_neighborhoodid: 65209946,
					// 	id: 69000701.0,
					// 	dealsInRooms: [
					// 		{ roomNum: 3.0 },
					// 		{ roomNum: 4.0 },
					// 		{ roomNum: 5.0 },
					// 		{ roomNum: 6.0 },
					// 	],
					// 	title: "אלעזר דוד",
					// },
				],
				showMap: true,
			};
		},
		methods: {
			checkExtentIntersection(extent1, extent2) {
				// Validate input
				if (!extent1 || !extent2 || extent1.length !== 4 || extent2.length !== 4) {
					console.warn('Invalid extent inputs');
					return false;
				}

				try {
					const [x_min1, x_max1, y_min1, y_max1] = extent1;
					const [x_min2, x_max2, y_min2, y_max2] = extent2;

					// Check for no intersection conditions
					const noXIntersection = x_max1 < x_min2 || x_max2 < x_min1;
					const noYIntersection = y_max1 < y_min2 || y_max2 < y_min1;

					// Intersects if neither X nor Y have a no-intersection condition
					return !(noXIntersection || noYIntersection);
				} catch (error) {
					console.error('Error checking extent intersection:', error);
					return false;
				}
			},
			convertExtentStructure(extentObj) {
				if (!extentObj || typeof extentObj !== 'object') {
					console.warn('Invalid extent object');
					return null;
				}

				try {
					return [
					extentObj.xmin,   // x_min
					extentObj.xmax,   // x_max
					extentObj.ymin,   // y_min
					extentObj.ymax    // y_max
					];
				} catch (error) {
					console.error('Error converting extent structure:', error);
					return null;
				}
			},
			convertWktToExtent(wkt) {
				// Validate input
				if (!wkt || typeof wkt !== 'string') {
					console.warn('Invalid WKT input');
					return null;
				}

				try {
					// Remove POLYGON(( and )) and handle multiple whitespace
					const coordString = wkt
					.replace(/^POLYGON\s*\(\(/,'')
					.replace(/\)\)$/,'')
					.trim();
					
					// Split coordinates, handling potential multiple spaces
					const coords = coordString
					.split(/,\s*/)
					.map(coord => {
						// Split by one or more whitespace characters and convert to numbers
						const [x, y] = coord.trim().split(/\s+/).map(Number);
						return { x, y };
					})
					.filter(coord => !isNaN(coord.x) && !isNaN(coord.y));
					
					// Calculate extent
					const x_values = coords.map(coord => coord.x);
					const y_values = coords.map(coord => coord.y);
					
					return [
					Math.min(...x_values),    // x_min
					Math.max(...x_values),    // x_max
					Math.min(...y_values),    // y_min
					Math.max(...y_values)     // y_max
					];
				} catch (error) {
					console.error('Error converting WKT to extent:', error);
					return null;
				}
			},

			/**
			 * Converts an extent back to a WKT Polygon
			 * @param {number[]} extent - Extent array [x_min, x_max, y_min, y_max]
			 * @returns {string} - WKT Polygon representation
			 */
			convertExtentToWkt(extent) {
				// Validate input
				if (!Array.isArray(extent) || extent.length !== 4) {
					console.warn('Invalid extent input');
					return null;
				}

				try {
					const [x_min, x_max, y_min, y_max] = extent;
					
					// Create polygon coordinates in counter-clockwise order
					const polygonCoords = [
					`${x_min} ${y_min}`,
					`${x_max} ${y_min}`,
					`${x_max} ${y_max}`,
					`${x_min} ${y_max}`,
					`${x_min} ${y_min}`  // Closing point (same as first)
					];
					
					return `POLYGON((${polygonCoords.join(', ')}))`;
				} catch (error) {
					console.error('Error converting extent to WKT:', error);
					return null;
				}
			},
			allowMapSelection(selectionType) {
				var appVue = this;
				this.$store.state.mapSelectionAllowed =!this.$store.state.mapSelectionAllowed;
				if (this.$store.state.mapSelectionAllowed == false) {
					this.$store.state.mapSelectionType = null;
					this.mixin_setMap(this);
					this.$store.state.clickedNeighborhoodName = null;
					return;
				}
				this.$store.state.mapSelectionType = selectionType;
				var s_types = {
					Point: govmap.geometryType.POINT,
					Polygon: govmap.geometryType.POLYGON,
					Rectangle: govmap.geometryType.CIRCLE,
				};
				govmap.draw(s_types[selectionType]).progress(function (e) {
					const coords = e.wkt.match(/POINT\(([^)]+)\)/)[1];
					// Split into x and y
					const [x, y] = coords.split(' ').map(Number);	
					var LayerName = appVue.$route.query.view == "neighborhood_rent" ? "KSHTANN_NEIGHBORHOODS" : "KSHTANN_SETL_AREA";
					var params = {
						LayerName: LayerName,
						Point: {
							x: x,
							y: y,
						},
						Radius: 1,
					};
					// only if view=neighborhood_rent...
					if (appVue.$route.query.view == "neighborhood_rent") {
						govmap.getLayerData(params).then(function (response) {
							if (response.data == null) {
								appVue.$store.state.clickedNeighborhoodName = null;
								appVue.$store.state.clickedRentPrice = null;
								// stop highlight
								//govmap.clearSelection();
								appVue.allowMapSelection(selectionType);
								return;
							}
							const uniq_id = response.data[0].Fields[1].Value;
							// get neighborhood data
							const d_url =
								appVue.$store.state.config.s3_page_base +
								"/neighborhood/rent/" +
								uniq_id +
								".json" + 
								"?t=" + new Date().getTime();
							fetch(d_url).then(function (response) {
								const data = response.json();
								data.then(function (e) {
									//const init_x = e.x;
									//const init_y = e.y;
									//set store neighborhood, setlName
									appVue.$store.state.clickedNeighborhoodName =
										e.neighborhoodName;
									//get last
									const gr_data = e.trends.rooms[3].graphData;
									// take last price fro lastYearAvgPrice
									appVue.$store.state.clickedRentPrice = e.trends.rooms[3].summary.lastYearAvgPrice;
									appVue.$store.state.clickedRentPrice_3 = e.trends.rooms[0].summary.lastYearAvgPrice;
									appVue.$store.state.clickedRentPrice_4 = e.trends.rooms[1].summary.lastYearAvgPrice;
									appVue.$store.state.clickedRentPrice_5 = e.trends.rooms[2].summary.lastYearAvgPrice;
									if (appVue.$store.state.clickedRentPrice == null){
										var  lastIndex = 0;
										lastIndex = gr_data.findIndex(price =>  price.neighborhoodPrice > 0); 
										if (!gr_data.some(num => num > 0)) {
											lastIndex = 1;
										}
										appVue.$store.state.clickedRentPrice = gr_data[lastIndex].neighborhoodPrice;
									}
		
									// highlight and zoom
									var params = {
										layerName: "KSHTANN_NEIGHBORHOODS",
										fieldName: "UNIQ_ID",
										fieldValues: [e.neighborhoodId],
										highlight: true,
										fillColor: [176, 228, 248, 0.5],
									};
									govmap.searchInLayer(params);
									appVue.$store.state.mapSelectionAllowed = false;
									appVue.allowMapSelection(selectionType);
								});
							});

							
						});
					}
					if (appVue.$route.query.view == "settlement_rent") {
							govmap.getLayerData(params).then(function (response) {

							if (response.data == null) {
								appVue.$store.state.clickedNeighborhoodName = null;
								appVue.$store.state.clickedRentPrice = null;
								// stop highlight
								//govmap.clearSelection();
								appVue.allowMapSelection(selectionType);
								return;
							}

							const uniq_id = response.data[0].Fields[3].Value;
							const d_url =
								appVue.$store.state.config.s3_page_base +
								"/settlement/rent/" +
								uniq_id +
								".json" + 
								"?t=" + new Date().getTime();
							fetch(d_url).then(function (response) {
								const data = response.json();
								data.then(function (e) {
									//set store neighborhood, setlName
									appVue.$store.state.clickedNeighborhoodName = e.settlementName;
									//get last
									const gr_data = e.trends.rooms[3].graphData;
									// take last price fro lastYearAvgPrice
									appVue.$store.state.clickedRentPrice = e.trends.rooms[3].summary.lastYearAvgPrice;
									appVue.$store.state.clickedRentPrice_3 = e.trends.rooms[0].summary.lastYearAvgPrice;
									appVue.$store.state.clickedRentPrice_4 = e.trends.rooms[1].summary.lastYearAvgPrice;
									appVue.$store.state.clickedRentPrice_5 = e.trends.rooms[2].summary.lastYearAvgPrice;
									if (appVue.$store.state.clickedRentPrice == null){
										var  lastIndex = 0;
										lastIndex = gr_data.findIndex(price =>  price.neighborhoodPrice > 0); 
										if (!gr_data.some(num => num > 0)) {
											lastIndex = 1;
										}
										appVue.$store.state.clickedRentPrice = gr_data[lastIndex].neighborhoodPrice;
									}
									// highlight and zoom
									var params = {
										layerName: "KSHTANN_SETL_AREA",
										fieldName: "SETL_CODE",
										fieldValues: [uniq_id],
										highlight: true,
										fillColor: [176, 228, 248, 0.5],
									};
									govmap.searchInLayer(params);
									appVue.$store.state.mapSelectionAllowed = false;
									appVue.allowMapSelection(selectionType);
								});
							});
						});
					}

				});		
			},
			dissallowMapSelection() {
				// hide clickedNeighborhoodName
				this.$store.state.clickedNeighborhoodName = null;

				this.$store.state.mapSelectionAllowed = false;
				this.mixin_setMap(this);
			},
			tuggleShare() {
				this.showShare = !this.showShare;
			},
			async waitMapLoaded() {
				if (this.mapSet == true) {
					return;
				}
				this.$store.state.showMap = true;
				if (this.scriptLoaded == false) {
					await this.mixin_wait_scriptLoadedIsTrue();
				}
				if (this.$store.state.setlCode == null) {
					await this.mixin_waitForSetlUpdate(this);
				}
				setTimeout(() => {
					if (document.getElementById("map") == null) {
						this.$store.state.mapStatus = 1;
					}
					this.mixin_createMap(this);
					this.mixin_setMap(this);
					this.mapSet = true;
				}, 100);
			},
			zoomRow(e) {
				const polygonId = e.polygonId;

				// select feature
				// select feature on map

				/* global govmap */
				govmap.searchInLayer({
					layerName: "KSHTANN_ASSETS",
					fieldName: "POLYGON_ID",
					fieldValues: [polygonId],
					highlight: true,
					outLineColor: [255, 0, 0, 1],
					fillColor: [0, 255, 0, 0.5],
				});
			},
			filterDealsPeriods(value, text) {
				// get selected deals period
				this.selectedDealsPeriod = text;
			},
			filterAssetType(value, text) {
				// get selected asset type
				this.selectedAssetType = text;
			},
			filterDealType(value, text) {
				// get selected deal type
				this.selectedDealType = text;
			},
			goToNeighborhood(neighborhoodId) {
				// get the base url domain...
				const baseUrl = window.location.protocol + "//" + window.location.host;
				const newPath =
					baseUrl + `/neighborhood/${neighborhoodId}/rent/pricing`;

				// Navigate to the new URL using window.location
				window.location.href = newPath;
			},

			tableSort(sortValue) {
				this.selectedSortOption = sortValue;
				// Here you can add any additional logic for handling the selected sort option
				switch (sortValue) {
					case "dateDesc":
						this.$store.state.deals.sort(
							(a, b) => new Date(a.dealDate) - new Date(b.dealDate),
						);
						break;
					case "dateAsc":
						this.$store.state.deals.sort(
							(a, b) => new Date(b.dealDate) - new Date(a.dealDate),
						);
						break;
					case "priceDesc":
						this.$store.state.deals.sort(
							(a, b) =>
								parseFloat(a.dealAmount.replace(/,|₪/g, "")) -
								parseFloat(b.dealAmount.replace(/,|₪/g, "")),
						);
						break;
					case "priceAsc":
						this.$store.state.deals.sort(
							(a, b) =>
								parseFloat(b.dealAmount.replace(/,|₪/g, "")) -
								parseFloat(a.dealAmount.replace(/,|₪/g, "")),
						);
						break;
					case "roomNumDesc":
						this.$store.state.deals.sort((a, b) => a.roomNum - b.roomNum);
						break;
					case "roomNumAsc":
						this.$store.state.deals.sort((a, b) => b.roomNum - a.roomNum);
						break;
					default:
						this.$store.state.deals.sort(
							(a, b) => new Date(a.dealDate) - new Date(b.dealDate),
						);
						break;
				}
			},
			toggleShowFilter() {
				this.showFilterOptions = !this.showFilterOptions;
			},
			toggleShowSort() {
				this.showSort = !this.showSort;
			},
			isSelected(roomValue) {
				return this.selectedRooms.includes(roomValue);
			},
			toggleRoom(roomValue) {
				this.page = 1;
				if (this.isSelected(roomValue)) {
					this.selectedRooms = this.selectedRooms.filter(
						(value) => value !== roomValue,
					); // Remove the room
				} else {
					this.selectedRooms.push(roomValue); // Add the room
				}
			},
			customSort(a, b) {
				return a.toDate() - b.toDate();
			},
			go() {
				if (this.page < this.roundPages) {
					this.page = this.page + 1;
				}
			},
			goBack() {
				if (this.page > 1) {
					this.page = this.page - 1;
				}
			},
			toggleCollapse(index) {
				this.selectedRow = this.selectedRow === index ? null : index;
			},
			isCollapsed(index) {
				return this.$store.state.deals[index].collapsed;
			},
			selectTab(tab) {
				// Remove 'active' class from all tabs
				this.tabs.forEach((t) => {
					const element = document.querySelector(
						`[data-rb-event-key="${t.key}"]`,
					);
					if (element) {
						element.classList.remove("active");
					}
				});

				// Add 'active' class to the selected tab
				this.selectedTab = tab.key;
				const selectedElement = document.querySelector(
					`[data-rb-event-key="${tab.key}"]`,
				);
				if (selectedElement) {
					selectedElement.classList.add("active");
				}
			},
		},

		watch: {
			mapStatus() {
				var appVue = this;
				if (appVue.zoomingTo == true) {
					return;
				}
				if (appVue.mapStatus > 0) {
					appVue.zoomingTo = true;
					setTimeout(() => {
						var view = appVue.$route.query.view;
						if (view == "neighborhood_info") {
							//filter and zoom
							var params = {
								layerName: "KSHTANN_NEIGHBORHOODS",
								whereClause: "UNIQ_ID = " + appVue.$store.state.neighborhoodId,
								zoomToExtent: true,
							};
							govmap.filterLayers(params);
						} else if (view == "settlement_info") {
							// filter and zoom
							var params1 = {
								layerName: "KSHTANN_SETL_AREA",
								whereClause: "SETL_CODE = " + appVue.$store.state.setlCode,
								zoomToExtent: true,
							};
							govmap.filterLayers(params1);
						} else {
							//zoom to settlement or neighborhood
							appVue.zoomingTo = false;
							return;
						}
						appVue.zoomingTo = false;
					}, 1000);
				}
			},
			selectedTab() {
				//store
				this.$store.state.selectedTab = this.selectedTab;
				// get graph_component ref
				//this.$refs.graph_component.currentTab = this.selectedTab;
			},
			// currentTab() {
			//   this.updateGraphData();
			// },
		},

		mounted() {
			this.$store.state.loading == true;
			if (!this.mixin_scriptLoaded) {
				this.mixin_loadScript();
			}

			// createMap
			this.waitMapLoaded();
			//this.$store.state.mapSelectionAllowed = true;

			
			window.scrollTo(0, 0);
		},
		computed: {
			selectFromMapToolTip(){
				// check if page is view=settlement_rent 
				if (this.$route.query.view == "settlement_rent") {
					return "בחר ישוב במפה";
				}
				//or view=neighborhood_rent
				else if (this.$route.query.view == "neighborhood_rent") {
					return "בחר שכונה במפה";
				}
				else {
					return "בחר מהמפה";
				}
			},
			mapStatus(){
				return this.$store.state.mapStatus;
			},

			upOrDown_s() {
				if (this.$store.state.priceIncreases > 0) {
					return "עלו";
				} else if (this.$store.state.priceIncreases < 0) {
					return "ירדו";
				} else {
					return null;
				}
			},
			buy_path() {
				if (typeof this.mixin_computeTargetPath().buy == "undefined") {
					return "/";
				}
				return this.mixin_computeTargetPath().buy;
			},
			rent_path() {
				if (typeof this.mixin_computeTargetPath().rent == "undefined") {
					return "/";
				}
				return this.mixin_computeTargetPath().rent;
			},
			info_path() {
				if (typeof this.mixin_computeTargetPath().info == "undefined") {
					return "/";
				}
				return this.mixin_computeTargetPath().info;
			},

			checkRouteType() {
				//var st = this.$route.name;
				var st = this.$route.query.view;
				return st;
			},
			clickedNeighborhoodName() {
				return this.$store.state.clickedNeighborhoodName;
			},
			clickedRentPrice() {
				return this.$store.state.clickedRentPrice;
			},
			clickedRentPrice_3() {
				return this.$store.state.clickedRentPrice_3;
			},
			clickedRentPrice_4() {
				return this.$store.state.clickedRentPrice_4;
			},
			clickedRentPrice_5() {
				return this.$store.state.clickedRentPrice_5;
			},
			resultTypeDesc() {
				//var st = this.$route.name;
				var st = this.$route.query.view;
				if (st == "address_rent") {
					return "כתובת";
				} else if (st == "street_rent") {
					return "רחוב";
				} else if (st == "neighborhood_rent") {
					return "שכונה";
				} else if (st == "settlement_rent") {
					return "יישוב";
				} else {
					return "כתובת";
				}
			},
			upOrDown() {
				if (this.getPriceDifferencePercentage < 0) {
					return "ירידת מחירים";
				} else {
					return "עליית מחירים";
				}
			},
			getPriceDifferencePercentage() {
				if (this.selectedTab == "all") {
					return this.$store.state.priceDifferencePercentage;
				} else if (this.selectedTab == "3") {
					return this.$store.state.priceDifferencePercentage_3;
				} else if (this.selectedTab == "4") {
					return this.$store.state.priceDifferencePercentage_4;
				} else if (this.selectedTab == "5") {
					return this.$store.state.priceDifferencePercentage_5;
				} else {
					return null;
				}
			},
			getLastYearAvgPrice() {
				if (this.selectedTab == "all") {
					if (this.$store.state.lastYearAvgPrice == null) {
						return "null";
					}
					return this.$store.state.lastYearAvgPrice.toLocaleString("he-IL");
				} else if (this.selectedTab == "3") {
					if (this.$store.state.lastYearAvgPrice_3 == null) {
						return null;
					}
					return this.$store.state.lastYearAvgPrice_3.toLocaleString("he-IL");
				} else if (this.selectedTab == "4") {
					if (this.$store.state.lastYearAvgPrice_4 == null) {
						return null;
					}
					return this.$store.state.lastYearAvgPrice_4.toLocaleString("he-IL");
				} else if (this.selectedTab == "5") {
					if (this.$store.state.lastYearAvgPrice_5 == null) {
						return null;
					}
					return this.$store.state.lastYearAvgPrice_5.toLocaleString("he-IL");
				} else {
					return null;
				}
			},
			getLastQuarterlyAvgPrice() {
				if (this.selectedTab == "all") {
					if (this.$store.state.lastQuarterlyAvgPrice == null) {
						return null;
					}
					return this.$store.state.lastQuarterlyAvgPrice.toLocaleString(
						"he-IL",
					);
				} else if (this.selectedTab == "3") {
					if (this.$store.state.lastQuarterlyAvgPrice_3 == null) {
						return null;
					}
					return this.$store.state.lastQuarterlyAvgPrice_3.toLocaleString(
						"he-IL",
					);
				} else if (this.selectedTab == "4") {
					if (this.$store.state.lastQuarterlyAvgPrice_4 == null) {
						return null;
					}
					return this.$store.state.lastQuarterlyAvgPrice_4.toLocaleString(
						"he-IL",
					);
				} else if (this.selectedTab == "5") {
					if (this.$store.state.lastQuarterlyAvgPrice_5 == null) {
						return null;
					}
					return this.$store.state.lastQuarterlyAvgPrice_5.toLocaleString(
						"he-IL",
					);
				} else {
					return null;
				}
			},
		},
	};
</script>

<style scoped>


	@media screen and (max-width: 1350px) {
		.map_side_wrapper {
			width: 100%;
		}

	}


	@media screen and (max-width: 768px) {
		.priceBox_main{
			/* locate in the center (right left 50%) of its container 
			stick to the top*/
			position: absolute;
			top: 10px;
			left: 50%;
			transform: translateX(-50%);
		}
		
	}




	.grid-container {
		display: grid;
		grid-template-columns: 10% 80% 10%; /* Three columns: 10%, 80%, 10% */
		align-items: center; /* Optional: Centers items vertically within the grid container */
		/* ... other styles ... */
	}

	div.scrollmenu {
		display: block;
		overflow: auto;
		white-space: nowrap;
		z-index: -1;
		margin-top: 120px;
	}

	div.scrollmenu a {
		display: inline-block;
		color: white;
		text-align: center;
		padding: 14px;
		text-decoration: none;
		z-index: -1;
		color: black;
	}

	div.scrollmenu a:hover {
		background-color: tr;
		z-index: -1;
	}

	.details-row {
		display: none;
	}
	.fade-enter-active {
		transition: opacity 0.5s;
	}

	.fade-enter,
	.fade-leave-active {
		opacity: 0;
	}

	#wrapper {
		position: relative;
		/*background:#333;*/
		height: 100%;
	}

	.profile-main-loader {
		position: fixed !important;
		left: 50%;
		right: 50%;
		top: 50%;
		bottom: 50%;
		width: 200px;
		height: 200px; /* assuming you want it square */
		margin-left: -100px; /* half of the width */
		margin-top: -100px; /* half of the height */
		z-index: 900 !important;
	}

	.profile-main-loader .loader {
		position: relative;
		margin: 0px auto;
		width: 150px;
		height: 150px;
	}
	.profile-main-loader .loader:before {
		content: "";
		display: block;
		padding-top: 100%;
	}

	.circular-loader {
		-webkit-animation: rotate 2s linear infinite;
		animation: rotate 2s linear infinite;
		height: 100%;
		-webkit-transform-origin: center center;
		-ms-transform-origin: center center;
		transform-origin: center center;
		width: 100%;
		position: absolute;
		top: 0;
		left: 0;
		margin: auto;
	}

	.loader-path {
		stroke-dasharray: 150, 200;
		stroke-dashoffset: -10;
		-webkit-animation:
			dash 1.5s ease-in-out infinite,
			color 6s ease-in-out infinite;
		animation:
			dash 1.5s ease-in-out infinite,
			color 6s ease-in-out infinite;
		stroke-linecap: round;
	}

	@-webkit-keyframes rotate {
		100% {
			-webkit-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}

	@keyframes rotate {
		100% {
			-webkit-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}
	@-webkit-keyframes dash {
		0% {
			stroke-dasharray: 1, 200;
			stroke-dashoffset: 0;
		}
		50% {
			stroke-dasharray: 89, 200;
			stroke-dashoffset: -35;
		}
		100% {
			stroke-dasharray: 89, 200;
			stroke-dashoffset: -124;
		}
	}
	@keyframes dash {
		0% {
			stroke-dasharray: 1, 200;
			stroke-dashoffset: 0;
		}
		50% {
			stroke-dasharray: 89, 200;
			stroke-dashoffset: -35;
		}
		100% {
			stroke-dasharray: 89, 200;
			stroke-dashoffset: -124;
		}
	}
	@-webkit-keyframes color {
		0% {
			stroke: #1990d4;
		}
		40% {
			stroke: #1990d4;
		}
		66% {
			stroke: #1990d4;
		}
		80%,
		90% {
			stroke: #1990d4;
		}
	}
	@keyframes color {
		0% {
			stroke: #1990d4;
		}
		40% {
			stroke: #1990d4;
		}
		66% {
			stroke: #1990d4;
		}
		80%,
		90% {
			stroke: #1990d4;
		}
	}

	.loading-container {
		display: flex;
		justify-content: center; /* Center horizontally */
		align-items: center; /* Center vertically */
		height: 100vh; /* Optional: Set the height to 100% of the viewport height */
	}

	.loader-svg {
		width: 200px; /* Adjust the width of the SVG as needed */
		height: 200px; /* Adjust the height of the SVG as needed */
	}
</style>
